module.exports = __webpack_public_path__ + "static/img/label_remark_hq_pack.7c0fc09b.png";